import React from 'react';
import { useTranslation } from 'react-i18next';

interface MutationCardProps {
  title: string;
  mutations: {
    new: number;
    updated: number;
    removed: number;
  };
  className?: string;
}

export const MutationCard: React.FC<MutationCardProps> = ({
  title,
  mutations,
}) => {
  const { t } = useTranslation();
  return (
    <div className="tw-flex-1 tw-p-4">
      <div className="tw-text-center tw-font-semibold tw-text-gray-700 tw-font-inter tw-mb-[10px]">
        {title}
      </div>
      <div className="tw-flex tw-justify-around">
        <div className="tw-text-center">
          <div className="tw-text-3xl tw-font-medium tw-text-gray-900">
            {mutations.new}
          </div>
          <div className="tw-text-sm tw-font-medium tw-text-gray-600">
            {t('organisation:mutation_card_new')}
          </div>
        </div>
        <div className="tw-text-center">
          <div className="tw-text-3xl tw-font-medium tw-text-gray-900">
            {mutations.updated}
          </div>
          <div className="tw-text-sm tw-font-medium tw-text-gray-600">
            {t('organisation:mutation_card_updated')}
          </div>
        </div>
        <div className="tw-text-center">
          <div className="tw-text-3xl tw-font-medium tw-text-gray-900">
            {mutations.removed}
          </div>
          <div className="tw-text-sm tw-font-medium tw-text-gray-600">
            {t('organisation:mutation_card_removed')}
          </div>
        </div>
      </div>
    </div>
  );
};
